import { render } from "./DisplayQuotation.vue?vue&type=template&id=486ffdaa&scoped=true"
import script from "./DisplayQuotation.vue?vue&type=script&lang=js"
export * from "./DisplayQuotation.vue?vue&type=script&lang=js"

import "./DisplayQuotation.vue?vue&type=style&index=0&id=486ffdaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-486ffdaa"

export default script